import {
    Modal, Button, ModalHeader, ModalBody, ModalFooter, Badge,
} from 'appkit-react';

import '../styles/tenantMappingDeleteModal.scss';

const TenantMappingDeleteWarningModal = ({
    showConfirmDelete, setShowConfirmDelete, setConfirmReset,
    setShowEditTenantPanel, setShowAddTenantPanel,
}) => (
    <div className="true-comply__tenant-mapping-delete-reset_warning_modal">
        <Modal
            className="action-modal-showcase"
            visible={showConfirmDelete}
            onCancel={() => setShowConfirmDelete(false)}
        >
            {/* <ModalHeader>
                <div className="a-modal-example-header">
                    <div className="modal-title-left">
                        <Badge className="example-badge" type="warning">WARNING</Badge>
                    </div>
                </div>
            </ModalHeader> */}
            <ModalBody>
                <div style={{ fontSize: '1.5rem', textAlign: 'center' }}>
                    <span
                        className="appkiticon icon-alert-outline"
                    />
                </div>
                <div
                    className="true-comply__tenant-mapping-delete-reset_warning_modal_description"
                >
                    Are you sure you want to delete this tenant mapping?
                </div>
            </ModalBody>
            <ModalFooter className="a-apply-theme-border-top-gray-level-6">
                <div className="button-comp">
                    <Button
                        kind="transparent"
                        gray
                        onClick={
                            () => {
                                setConfirmReset(false);
                                setShowConfirmDelete(false);
                            }
                        }
                        size="lg"
                    >
                        CANCEL
                    </Button>
                    <Button
                        kind="transparent"
                        onClick={
                            () => {
                                setConfirmReset(true);
                                setShowConfirmDelete(false);
                                setShowAddTenantPanel(false);
                                setShowEditTenantPanel(false);
                            }
                        }
                        size="lg"
                    >
                        CONFIRM
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    </div>
);

export default TenantMappingDeleteWarningModal;
